import Visible from "../../common/Visible";
import BrokerCreationTemplate from "./BrokerCreationTemplate";
import PersonSelect from "./PersonSelect";
import PuniBroker from "./PuniBroker";
import RetailBroker from "./RetailBroker";
import SurplusBroker from "./SurplusBroker";
import { Grid } from "@mui/material";
import Component from "components/Component";
import Disabled from "components/common/Disabled";
import { sortBrokerList } from "components/inputs/program/BrokerSupport";
import ProducerBroker from "components/inputs/program/ProducerBroker";
import WholesaleBroker from "components/inputs/program/WholesaleBroker";
import * as labels from "config.labels";
import { connect } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as programActions from "store/actions/input/program/programActions";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";

const BrokerCreation = ({ onCreate, onClose }) => {
  const { data: brokers } = staticDataService.useListBrokersQuery();
  const [createBroker] = staticDataService.useCreateBrokerMutation();

  return (
    <BrokerCreationTemplate
      brokers={brokers}
      createBroker={createBroker}
      visibilityBaseTag={"<BrokerCreation>"}
      formId={"broker-creation-form"}
      title={"Add a new broker"}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const Broker = ({ broker, updateBroker, updatePaymentTerms }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const {
    data: brokers,
    refetch: refreshBrokers,
  } = staticDataService.useListBrokersQuery();
  const { data: generalConfiguration } = staticDataService.useConfigQuery(
    "general_configuration"
  );
  const sortedBrokers = sortBrokerList(brokers ?? []);

  const handleUpdateBroker = (selectedBroker) => {
    updateBroker(selectedBroker);
    const brokerDefaultPaymentDays =
      generalConfiguration?.brokerDefaultPaymentDays ?? {};
    const companyKey = Object.keys(brokerDefaultPaymentDays).find((key) =>
      selectedBroker?.company?.toLowerCase().trim().includes(key.toLowerCase())
    );
    if (companyKey) {
      updatePaymentTerms({ days: brokerDefaultPaymentDays[companyKey] });
    }
  };

  return (
    <Component
      title={translateLabel(labels.BROKER_TITLE, {
        default: "Broker",
      })}
      subtitle={translateLabel(labels.BROKER_SUBTITLE, {
        default: "The broker associated with this submission.",
      })}
    >
      <Disabled ifReadOnly>
        <Grid container direction={"column"} spacing={3}>
          <Grid item xs={12}>
            <PersonSelect
              person={broker}
              personList={sortedBrokers}
              onUpdatePerson={handleUpdateBroker}
              onUpdatePersonList={refreshBrokers}
              PersonCreationComponent={BrokerCreation}
            />
          </Grid>
          <Visible byTag={"input.program.puniBroker"} defaultVisible={false}>
            <Grid item xs={12}>
              <PuniBroker />
            </Grid>
          </Visible>
          <Visible byTag={"input.program.retailBroker"} defaultVisible={false}>
            <Grid item xs={12}>
              <RetailBroker />
            </Grid>
          </Visible>
          <Visible byTag={"input.program.surplusBroker"} defaultVisible={false}>
            <Grid item xs={12}>
              <SurplusBroker />
            </Grid>
          </Visible>
          <Visible
            byTag={"input.program.producerBroker"}
            defaultVisible={false}
          >
            <Grid item xs={12}>
              <ProducerBroker />
            </Grid>
          </Visible>
          <Visible
            byTag={"input.program.wholesaleBroker"}
            defaultVisible={false}
          >
            <Grid item xs={12}>
              <WholesaleBroker />
            </Grid>
          </Visible>
        </Grid>
      </Disabled>
    </Component>
  );
};

const mapStateToProps = (state) => ({
  broker: peopleSelectors.selectBroker(state),
});

const mapDispatchToProps = {
  updateBroker: peopleActions.updateBroker,
  updatePaymentTerms: programActions.updatePaymentTerms,
};

export default connect(mapStateToProps, mapDispatchToProps)(Broker);
